import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getCurrentBookingServicePersmissions } from '../../../../../../../../../data/actions'
import MembersDialog from './MembersDialog'
import Header from './components/Header'
import PermissionsTable from './components/PermissionsTable'
import {
  selectCurrentBookingServicePermissions,
  selectBookingMembers,
  selectWaitingPermissions,
} from '../../../../../../../../../data/selectors/tenantBookings'

const BookingPermissions = ({
  booking,
  waitingPermissions,
  getCurrentBookingServicePersmissions,
  service,
  tenantMembers,
  currentServicePermissions,
  loggedInPoPmDaimlerId,
}) => {
  const [modal, setModal] = useState({})
  const [members, setMembers] = useState([])
  const bookingMembers = tenantMembers.filter((member) =>
    Boolean(member.permission),
  )

  let premissionFreeMembers = tenantMembers.filter((member) =>
    Boolean(!member.permission),
  )

  const onSelectMember = (member) => {
    const currentMemberIndex = members.findIndex(
      (mmbr) => mmbr === member.daimlerId,
    )
    if (currentMemberIndex > -1) {
      setMembers(members.filter((mbr) => mbr !== member.daimlerId))
    } else {
      setMembers([...members, member.daimlerId])
    }
  }

  const handleAddMember = () => {
    setModal({
      mode: 'add',
      variant: 'members',
    })
  }

  const handleEditSelected = () => {
    setModal({ mode: 'edit', variant: 'members' })
  }

  useEffect(() => {
    getCurrentBookingServicePersmissions(booking, service)
  }, [])

  return (
    <div className="booking-permissions">
      <Header
        handleAddMember={handleAddMember}
        handleEditSelected={handleEditSelected}
        disabledAdd={
          !Boolean(
            premissionFreeMembers.length && currentServicePermissions.length,
          )
        }
        disabledEdit={
          !Boolean(members.length && currentServicePermissions.length)
        }
      />
      <PermissionsTable
        onSelectMember={onSelectMember}
        members={bookingMembers.map((member) => ({
          ...member,
          waitingMode: waitingPermissions.includes(member.daimlerId),
        }))}
        booking={booking}
        service={service}
        currentServicePermissions={currentServicePermissions}
        loggedInPoPmDaimlerId={loggedInPoPmDaimlerId}
      />
      {modal.variant === 'members' && (
        <MembersDialog
          onClose={() => setModal({})}
          booking={booking}
          mode={modal.mode}
          service={service}
          loggedInPoPmDaimlerId={loggedInPoPmDaimlerId}
          members={
            modal.mode === 'add'
              ? premissionFreeMembers
              : tenantMembers.filter((member) =>
                  members.includes(member.daimlerId),
                )
          }
        />
      )}
    </div>
  )
}

BookingPermissions.propTypes = {
  booking: PropTypes.shape({
    comment: PropTypes.string,
    endDate: PropTypes.string,
    id: PropTypes.number,
    packageName: PropTypes.string,
    prices: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        year: PropTypes.string,
        monthlyPrice: PropTypes.number,
        platformServicePackageId: PropTypes.string,
      }),
    ),
    provider: PropTypes.string,
    slug: PropTypes.string,
    startDate: PropTypes.string,
    tenantAcronym: PropTypes.string,
    tenantName: PropTypes.string,
  }),
  getCurrentBookingServicePersmissions: PropTypes.func,
  service: PropTypes.shape({
    description: PropTypes.string,
    id: PropTypes.number,
    name: PropTypes.string,
    provider: PropTypes.string,
    serviceKey: PropTypes.string,
    slug: PropTypes.string,
  }),
  tenantMembers: PropTypes.arrayOf(
    PropTypes.shape({
      comment: PropTypes.string,
      daimlerId: PropTypes.string,
      email: PropTypes.string,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      mbioId: PropTypes.string,
      permission: PropTypes.object,
      roles: PropTypes.arrayOf(PropTypes.string),
      tenantMemberUntil: PropTypes.string,
    }),
  ),
  currentServicePermissions: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
      id: PropTypes.number,
      name: PropTypes.string,
      providerOnly: PropTypes.bool,
      slug: PropTypes.string,
    }),
  ),
}
export default connect(
  (
    {
      tenantBookings: {
        bookingServicePermissions,
        tenantMembers,
        waitingPermissions,
      },
      sso,
    },
    ownProps,
  ) => {
    let loggedInPoPmDaimlerId = null
    const loggedInUserDaimlerId = sso.userId.toLowerCase()
    const loggedInUserMemberObject = tenantMembers.find(
      (member) => member.daimlerId === loggedInUserDaimlerId,
    )
    const userIsAdmin = sso.roles.includes('admin')
    const userIsPoPm =
      loggedInUserMemberObject?.roles.includes('PO') ||
      loggedInUserMemberObject?.roles.includes('PM')

    if (!userIsAdmin && loggedInUserMemberObject && userIsPoPm) {
      loggedInPoPmDaimlerId = loggedInUserDaimlerId
    }
    return {
      currentServicePermissions: selectCurrentBookingServicePermissions(
        ownProps.booking.id,
        ownProps.service.slug,
        bookingServicePermissions,
      ),
      tenantMembers: selectBookingMembers(
        tenantMembers,
        ownProps.booking.id,
        ownProps.service.slug,
        bookingServicePermissions,
      ),
      waitingPermissions: selectWaitingPermissions(
        waitingPermissions,
        ownProps.booking.id,
        ownProps.service.slug,
      ),
      loggedInPoPmDaimlerId,
    }
  },
  {
    getCurrentBookingServicePersmissions,
  },
)(BookingPermissions)
